import { FormattedText } from "@tm/ui-widgets/components";
import { theme } from "@tm/utility/global";
import RegionModalDweb from "../RegionModalDweb/RegionModalDweb";
import { PopularDescriptionWrap } from "./DescriptionModal.style";

interface ModalInterface {
  value?: string;
  handleDescriptionModal?: any;
  title?: string;
}
const DescriptionModal = ({
  handleDescriptionModal,
  value,
  title,
}: ModalInterface) => {
  return (
    <RegionModalDweb handleClick={handleDescriptionModal} customTitle={title}>
      <PopularDescriptionWrap>
        <FormattedText
          value={"Countries Covered: "}
          baseStyle={{
            fontWeight: "bold",
            color: theme.greyText,
            fontSize: "xs",
          }}
        />
        <FormattedText value={value} />
      </PopularDescriptionWrap>
    </RegionModalDweb>
  );
};

export default DescriptionModal;
